import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=aca8bfc4&scoped=true&lang=pug&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=aca8bfc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca8bfc4",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/currents?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230331143208%2Fpages%2Fcompare-current-accounts%2F_provider%2F_code%2F_slug.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsCurrentsSummary: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/products/currents/summary.vue').default,WidgetsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/widgets/accordion.vue').default,ProductsCurrentsFeatures: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/products/currents/features.vue').default,WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/widgets/image.vue').default,ProductsCurrentsCharges: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/products/currents/charges.vue').default,ProductsCurrentsEligibility: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/products/currents/eligibility.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/site/feefo.vue').default})
